import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import poweredText from "../../../assets/images/powered-text.svg";
import { Input } from "../../../components/ui/input";
import { Button } from "../../../components/ui/button";
import { Card } from "../../../components/ui/card";
import { Label } from "../../../components/ui/label";
import { emailRegex, validateEmail } from "../../../utils/Validator";
import { appType } from "../../../utils/config/configHelpers";
import { UserServiceClientApi } from "../../../services/api/UserApiServices";
import { showToast } from "../../../components/ui/toaster";


const ForgotPassword = ({logoImage}) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();


  const handleSubmit = async () => {
    setSubmitting(true);

    const validationError = validateEmail(email);
    if (validationError) {
      setError(validationError);
      setSubmitting(false);
      return;
    } else {
      setError("");
    }

    const resetPasswordObj = {
      email,
      appType: appType
    };

    try {
      const response = await UserServiceClientApi.resetPassword(resetPasswordObj);
      handleSuccess(response);
    } catch (error) {
      handleError(error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleSuccess = (data) => {
    console.log('data', data)
    if (data?.success) {
      showToast('success', `If your email address is registered with us, you'll receive an OTP to reset your password shortly.`);
      setTimeout(() => {
        navigate('/verify', { state: { email: email, forgotPasswordOtp: true } });
      }, 1000);
    } else {
      if (data.errorCode === "UserNotFoundException") {
        showToast('error', `If your email address is registered with us, you'll receive an OTP to reset your password shortly.`);
      } else {
        showToast('error', data.message || "Something went wrong.");
      }
    }
  };

  const handleChange = (e) => {
    if (emailRegex.test(e.target.value)) {
      setError("");
    }

    setEmail(e.target.value);
  };

  const handleError = (error) => {
    showToast('error', error.message || "Error occurred while sending reset email.");
  };

  useEffect(() => {
    const handleEnterKey = (e) => {
      if (e.key === "Enter") {
        handleSubmit();
      }
    };

    window.addEventListener("keydown", handleEnterKey);
    return () => window.removeEventListener("keydown", handleEnterKey);
  }, [email]);

  return (
    <div className="sm:col-span-6 col-span-12 3xl:py-[60px] lg:px-[60px] lg:py-[20px] px-[10px] py-[30px] h-full">
      <div className="flex flex-col h-full justify-between max-w-[491px] w-full !mx-auto">
        <img
          className="mx-auto 3xl:w-[210px] lg:w-[180px] w-[140px]"
          src={logoImage}
          alt="Onship logo"
        />

        <div className="lg:px-[15px] lg:py-[30px] p-[15px] lg:mx-[25px] mx-[15px]">
          <h1 className="lg:text-size-30 text-size-20 text-black font-semibold text-center mb-3">
            Forgot Password
          </h1>
          <p className="text-gray-300 text-size-14 font-regular text-center mb-12">
            Enter email account associated with your account and we’ll send an email with OTP to reset your password.
          </p>
          <div className="space-y-[20px]">
            <Card>
              <div className="space-y-[17px]">
                <div className="space-y-2 relative mb-4">
                  <Label htmlFor="email">Email</Label>
                  <Input
                    type="email"
                    placeholder="Please enter your Email"
                    value={email}
                    inputError={error}
                    onChange={handleChange}
                  />
                  {error && (
                    <p className="text-red text-size-10 font-regular mt-1">{error}</p>
                  )}
                </div>
                <Button
                  className="text-white"
                  type="submit"
                  onClick={handleSubmit}
                  disabled={submitting}
                >
                  {submitting ? "Sending..." : "Send"}
                </Button>
                <Button
                  variant="customGray"
                  type="button"
                  onClick={() => navigate("/login")}
                >
                  Back to Login
                </Button>
              </div>
            </Card>
          </div>
        </div>

        <img
          className="mx-auto w-full max-w-[260px] 3xl:mt-[80px] lg:w-[231px] mt-[0] mb-6px"
          src={poweredText}
          alt="Onship"
        />
      </div>
    </div>
  );
};

export default ForgotPassword;
